document.addEventListener("DOMContentLoaded", function () {
  AOS.init();
  if (document.getElementsByClassName("splide").length != 0) {
    var splide = new Splide(".splide", {
      type: "loop",
      perPage: 4,
      pagination: false,
      breakpoints: {
        1024: {
          perPage: 1,
        },
      },
      autoplay: true,
    });
    splide.mount();
  }

  //changing the meny bar
  let options = {
    //root: null, //document.querySelector("#main-menu"),
    rootMargin: "0px",
    threshold: [0.3],
  };

  let observer = new IntersectionObserver(callback, options);

  let targets = document.querySelectorAll(".growing-line");
  for (var target of targets) {
    //console.log("observe: ", target);
    observer.observe(target);
  }
  let home = document.querySelector("#trojniak-home");
  if (home) {
    observer.observe(home);
  }

  //observer.observe(document.querySelector("#tradycja"));

  jQuery(".navbar-burger").on("click", menu_selected);
  jQuery(".navbar-menu").on("click", menu_selected);
  jQuery(".trojniak-add-to-cart").on("click", trojniak_add_to_cart);

  // required to refresh woocommerce notices for OceanWP ajax add to cart.
  jQuery("body").on("added_to_cart", function (e) {
    console.log(e);
    //alert('added'+e);
  });
});

const menu_selected = (event) => {
  const hamburger = jQuery(event.currentTarget).hasClass("navbar-burger");
  const nav = jQuery(".navbar-menu");
  const kids = jQuery(".navbar-burger").children();
  console.log("menu_selected");
  if (nav.hasClass("opacity-0")) {
    if (hamburger) {
      nav
        .removeClass("opacity-0")
        .addClass("opacity-80")
        .removeClass("translate-x-full")
        .addClass("translate-x-0");
      kids.each(function (i) {
        const className = "line" + (i + 1);
        jQuery(this).addClass(className);
      });
    }
  } else {
    nav
      .removeClass("opacity-80")
      .addClass("opacity-0")
      .removeClass("translate-x-0")
      .addClass("translate-x-full");
    kids.each(function (i) {
      const className = "line" + (i + 1);
      jQuery(this).removeClass(className);
    });
  }
};

let callback = (entries, observer) => {
  entries.forEach((entry) => {
    //console.log("callback;", entry.target);
    if (entry.isIntersecting) {
      switch (entry.target.id) {
        case "logo-main":
          jQuery("#logo-main").addClass("opacity-0").removeClass("opacity-100");
          break;
        case "trojniak-home":
          jQuery(".nav-mobile").addClass("").removeClass("bg-black opacity-80");
          console.log("nasze_miody in");
          break;
        default:
          jQuery(entry.target) //"#" + entry.target.id + " .growing-line")
            .addClass("w-full")
            .removeClass("w-0");
      }
    } else {
      switch (entry.target.id) {
        case "logo-main":
          jQuery("#logo-main").addClass("opacity-100").removeClass("opacity-0");
          break;
        case "trojniak-home":
          jQuery(".nav-mobile").addClass("bg-black opacity-80").removeClass("");

          console.log("nasze_miody out");
          break;
        default:
          jQuery(entry.target) //"#" + entry.target.id + " .growing-line")
            .addClass("w-0")
            .removeClass("w-full");
      }
    }

    // Each entry describes an intersection change for one observed
    // target element:
    //   entry.boundingClientRect
    //   entry.intersectionRatio
    //   entry.intersectionRect
    //   entry.isIntersecting
    //   entry.rootBounds
    //   entry.target
    //   entry.time
  });
};

const trojniak_add_to_cart = (event) => {
  console.log(event.currentTarget.dataset.productid);
  // console.log(
  //   "trojniak_add_to_cart:",
  //   jQuery(".trojniak-add-to-cart").data("productid")
  // );
  //alert("clicked");
  trojniak_AddToCart(event.currentTarget.dataset.productid);
};

function trojniak_AddToCart(product_id, quantity = 1) {
  // let's check is add-to-cart.min.js is enqueued and parameters are presented
  if ("undefined" === typeof wc_add_to_cart_params) {
    return false;
  }

  jQuery.post(
    wc_add_to_cart_params.wc_ajax_url
      .toString()
      .replace("%%endpoint%%", "add_to_cart"),
    {
      product_id: product_id,
      quantity: quantity, // quantity is hardcoced her
    },
    function (response) {
      if (!response) {
        return;
      }
      // redirect is optional and it depends on what is set in WooCommerce configuration
      if (response.error && response.product_url) {
        console.log("trojniak_AddToCart, response:", response.error);
        //window.location = response.product_url;
        return;
      }
      console.log(response);
      if ("yes" === wc_add_to_cart_params.cart_redirect_after_add) {
        window.location = wc_add_to_cart_params.cart_url;
        return;
      }
      //reload instead of adjusting cart with event becasue in 9.3.1 it stopped working
      //window.location.reload()


      // refresh cart fragments etc
      jQuery(document.body).trigger("added_to_cart", [
        response.fragments,
        response.cart_hash
      ]);
      jQuery(".wc-block-mini-cart__button").addClass("animate-bounce");
    }
  );
}
